import React from 'react';

export interface DatePickerTriggerContextType {
  isActive: boolean;
  setIsActive: (active: boolean) => void;
  openDatePicker: () => void;
  registerOpenCallback: (fn: () => void) => void;
}

const DatePickerTriggerContext =
  React.createContext<DatePickerTriggerContextType>({
    isActive: false,
    setIsActive: () => undefined,
    openDatePicker: () => undefined,
    registerOpenCallback: () => undefined,
  });

export default DatePickerTriggerContext;
